<template>
  <Dialogs :dialog="dialog" :handleClose="close">
    <template #content>
      <div class="dialog_content">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
          <el-form-item label="标题" prop="title">
            <el-input :disabled="data.title == '详情'" style="width:405px;" maxlength="100" v-model="form.title"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="产品logo" class="uploader" prop="logo">
            <div style="display: flex;">
              <el-upload class="avatar-uploader" action="" ref="upload" :auto-upload="false" :on-change="handleChange"
                :show-file-list="false" :before-upload="beforeAvatarUpload" :on-remove="handleRemove">
                <el-button class="upCss" size="small" v-if="data.title != '详情'">上传文件</el-button>
                <div slot="tip" class="el-upload__tip" v-if="data.title != '详情'">
                  <span>仅支持.png,.jpg,.svg,.webp的文件上传</span>
                  <!-- <span v-if="form.type=='1'">仅支持.png,.jpg,.svg,.mov,.mp4视频的上传</span> -->
                  <!-- <span v-else-if="form.type=='0'">支持doc,.docx,.xls,.pdf,.png,.jpg,.svg等格式的文件，且不超过500MB</span>
                  <span v-else-if="form.type=='2'||form.type=='3'">支持.png,.jpg,.svg等格式的文件，且不超过500MB</span> -->
                </div>

              </el-upload>
              <div v-if="form.logo" class="file-preview">
                <img :src="form.logo" alt="Preview" style="height: 50px;" />
                <el-button v-if="data.title != '详情'" type="text" @click="handleRemove"
                  class="delete-button">X</el-button>
              </div>
            </div>

          </el-form-item>
          <el-form-item label="公司名称" prop="companyName">
            <el-input :disabled="data.title == '详情'" style="width:405px;" maxlength="100" v-model="form.companyName"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="productName">
            <el-input :disabled="data.title == '详情'" style="width:405px;" maxlength="100" v-model="form.productName"
              placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="碳标签内容" style="height: 160px" prop='content'>
            <el-upload style="display: none;" class="quill-uploader" action="" :before-upload="beforeAvatarUploadTwo"
              :http-request="customUpload">
              <el-button class="upCss" size="small">上传文件</el-button>
              <div slot="tip" class="el-upload__tip">
                <span>仅支持.doc,.docx,.xls,.pdf .png,.jpg,.svg,.mov,.mp4的文件上传</span>
                <!-- <span v-if="form.type=='1'">仅支持.png,.jpg,.svg,.mov,.mp4视频的上传</span> -->
                <!-- <span v-else-if="form.type=='0'">支持doc,.docx,.xls,.pdf,.png,.jpg,.svg等格式的文件，且不超过500MB</span>
                  <span v-else-if="form.type=='2'||form.type=='3'">支持.png,.jpg,.svg等格式的文件，且不超过500MB</span> -->
              </div>
            </el-upload>
            <quill-editor v-maxWindow :disabled="data.title == '详情'" v-model="form.content" ref="quillEditor"
              :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
              @change="onEditorChange($event)" @ready="onEditorReady($event)">
            </quill-editor>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <!-- 按钮 -->
    <template #btns v-if="showBtn">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </template>
  </Dialogs>
</template>
<script>
import { carbonlabelEdit, carbonlabelSave, fileUpload } from "@/api/api"
import Dialogs from "@/components/dialogs/dialogs.vue"
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import imageResize from 'quill-image-resize-module'
import screen from '../../../../utils/Screen' //自定义v-screen 指令
// import  ImageDrop  from 'quill-image-drop-module'
// Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', imageResize)

// 字体设置
const fontSizeStyle = Quill.import('attributors/style/size') // 引入这个后会把样式写在style上
fontSizeStyle.whitelist = ['12px', '14px', '16px', '18px', '20px', '24px', '28px', '36px', '48px', '72px']
Quill.register(fontSizeStyle, true)
// 设置字体样式
const Font = Quill.import('attributors/style/font') // 引入这个后会把样式写在style上
const fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong']
Font.whitelist = fonts // 将字体加入到白名单
Quill.register(Font, true)
export default {
  props: ['dialog', 'handleClose', 'isView', 'formData'],

  directives: { screen },
  data() {
    return {
      data: {
        size: 720,
        visible: true,
        title: "新增",
      },
      loading: false,
      close: function () { },
      showBtn: false,
      // 提交表单
      form: {
        title: "", // 主题
        logo: "", // logo
        companyName: "",//公司名称
        productName: "",//产品名称
        content: ''//碳标签
      },
      // 校验
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: 'blur' },
        ],
        logo: [
          { required: true, message: "请上传图片logo", trigger: 'change' }
        ],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: 'blur' },
          { max: 20, message: "公司名称不能超过20个字符", trigger: 'blur' }
        ],
        productName: [
          { required: true, message: "请输入产品名称", trigger: 'blur' },
          { max: 20, message: "产品名称不能超过20个字符", trigger: 'blur' }
        ]
      },
      files: [],
      editorOption: {
        placeholder: '',
        theme: 'snow', // or 'bubble'
        placeholder: '请输入内容',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],        // 加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'],                      //引用，代码块

              [{ 'list': 'ordered' }, { 'list': 'bullet' }],     // 有序列表，无序列表
              [{ 'script': 'sub' }, { 'script': 'super' }],      // 下角标，上角标
              [{ 'indent': '-1' }, { 'indent': '+1' }],          // 缩进
              [{ 'direction': 'rtl' }],                         // 文字输入方向
              [{ 'align': [] }], // 居中

              ['image', 'video'],  // 上传图片、上传视频
              [{ 'size': ['small', false, 'large', 'huge'] }],  // 字体大小
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],// 标题
              [{ 'color': [] }, { 'background': [] }],          // 颜色选择
              [{ 'font': ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial'] }],// 字体
              ['clean'],                                       // 清除样式,

            ],
            handlers: {
              lineheight: (value) => {
                if (value) {
                  let quill = this.$refs.quillEditor.quill
                  quill.format('lineHeight', value)
                }
              },
              // 调用image上传事件（注意）
              image: (value) => {
                if (value) {
                  document.querySelector('.quill-uploader input').click()
                } else {
                  this.quill.format('image', false)
                }
              },
              video: (value) => {
                if (value) {
                  document.querySelector('.quill-uploader input').click()
                } else {
                  this.quill.format('video', false);
                }
              },
            },
          },
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false,
          },
          // ImageDrop:true,//拖动图片
          imageResize: {
            displayStytles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            }
          }
        },

      },
    }
  },

  mounted() {
    this.initEdit()
  },
  methods: {
    initEdit() {
      // toolbar标题
      const titleConfig = [
        { Choice: '.ql-insertMetric', title: '跳转配置' },
        { Choice: '.ql-bold', title: '加粗' },
        { Choice: '.ql-italic', title: '斜体' },
        { Choice: '.ql-underline', title: '下划线' },
        { Choice: '.ql-header', title: '段落格式' },
        { Choice: '.ql-strike', title: '删除线' },
        { Choice: '.ql-blockquote', title: '块引用' },
        { Choice: '.ql-code', title: '插入代码' },
        { Choice: '.ql-code-block', title: '插入代码段' },
        { Choice: '.ql-font', title: '字体' },
        { Choice: '.ql-size', title: '字体大小' },
        { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
        { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
        { Choice: '.ql-direction', title: '文本方向' },
        { Choice: '.ql-header[value="1"]', title: 'h1' },
        { Choice: '.ql-header[value="2"]', title: 'h2' },
        { Choice: '.ql-align', title: '对齐方式' },
        { Choice: '.ql-color', title: '字体颜色' },
        { Choice: '.ql-background', title: '背景颜色' },
        { Choice: '.ql-image', title: '图像' },
        { Choice: '.ql-video', title: '视频' },
        { Choice: '.ql-link', title: '添加链接' },
        { Choice: '.ql-formula', title: '插入公式' },
        { Choice: '.ql-clean', title: '清除字体格式' },
        { Choice: '.ql-script[value="sub"]', title: '下标' },
        { Choice: '.ql-script[value="super"]', title: '上标' },
        { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
        { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
        { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
        { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
        { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
        { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
        { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
        { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
        { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
        { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
        { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
        { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
        { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
        { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
        { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
        { Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐' },
        { Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐' },
        { Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐' }
      ]
      for (let item of titleConfig) {
        let tip = document.querySelector('.quill-editor ' + item.Choice)
        if (!tip) continue
        tip.setAttribute('title', item.title)
      }
    },
    // 提交
    async submitForm() {
      let bol = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          bol = false;
          return false;
        }
      });
      if (bol) {
        let res = ''
        if (this.form.id) {
          console.log(this.form.content)
          res = await carbonlabelEdit(this.form)
        } else {
          res = await carbonlabelSave(this.form)
        }
        if (res.data.code == 200) {
          this.data.visible = false
          this.$parent.getList()
          this.$message.success(res.data.message);
        } else this.$message.error(res.data.message);
      }
    },
    // 上传文件之前的钩子
    beforeAvatarUpload(file) {
      let isJPG
      isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/svg+xml" || // svg
        file.type == "image/webp"
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error(
          "仅支持.png,.jpg,.svg,.webp格式的文件"
        );
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 上传文件之前的钩子
    beforeAvatarUpload(file) {
      let isJPG
      isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/svg+xml" || // svg
        file.type == "image/webp"
      const isLt2M = file.size / 1024 / 1024 < 200;
      if (!isJPG) {
        this.$message.error(
          "仅支持.png,.jpg,.svg,.webp格式的文件"
        );
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 200MB!");
      }
      return isJPG && isLt2M;
    },
    handleChange(file, fileList) {
      // 清除之前的文件
      this.form.logo = null;
      const that = this
      // 读取文件并转换为Base64编码
      const reader = new FileReader();
      reader.onload = (e) => {
        this.form.logo = e.target.result;
        this.$forceUpdate()
      };
      reader.readAsDataURL(file.raw);
    },
    handleRemove(file, fileList) {
      this.form.logo = null;
      this.$message.success('文件已删除');
      this.$forceUpdate()
      this.$refs.upload.clearFiles()
    },
    // 失去焦点事件
    onEditorBlur(quill) {
      console.log('editor blur!', quill)
    },
    // 获得焦点事件
    onEditorFocus(quill) {
      console.log('editor focus!', quill)
    },
    // 准备富文本编辑器
    onEditorReady(quill) {
      console.log('editor ready!', quill)
    },
    // 内容改变事件
    onEditorChange({ quill, html, text }) {
      console.log('editor change!', quill, html, text)
      this.content = html
    },
    //自定义上传
    async customUpload(file) {
      await this.upload(file.file);
    },
    //开始上传的函数
    // async upload(file) {
    //   const searchParam = JSON.stringify({
    //     creatorCode: JSON.parse(localStorage.getItem("userInfo")).id,
    //     creatorName: JSON.parse(localStorage.getItem("userInfo")).name,
    //     filename: "",
    //   });
    //   const loading = this.$loading({
    //     lock: true,
    //     text: "正在上传文件...",
    //     spinner: "el-icon-loading",
    //     background: "rgba(0, 0, 0, 0.7)",
    //   });
    //   const formData = new FormData();
    //   formData.append("file", file);
    //   formData.append("searchParam", searchParam);
    //   const res = await fileUpload(formData);

    //   if (res.data.code == 200) {
    //     loading.close();
    //     let quill = this.$refs.quillEditor.quill
    //     let length = quill.getSelection().index
    //     quill.insertEmbed(length, 'image', res.data.data[0].fileVisitPath)
    //     // 调整光标到最后
    //     quill.setSelection(length + 1)
    //     // this.fileList.push({
    //     //   url: res.data.data[0].fileVisitPath,
    //     //   id: res.data.data[0].id,
    //     //   name: res.data.data[0].fileOldName,
    //     //   type: res.data.data[0].fileType,
    //     // });
    //     // this.form.accessory = [{
    //     //   url: res.data.data[0].fileVisitPath,
    //     //   id: res.data.data[0].id,
    //     //   name: res.data.data[0].fileOldName,
    //     //   type: res.data.data[0].fileType,
    //     // }]
    //   } else loading.close();
    // },
    //开始上传的函数
    async upload(file) {
      // 如果传的是图片
      if (file.type == 'image/png' || file.type == 'image/jpeg' || file.type == 'image/svg+xml' || file.type == 'image/webp') {
        const searchParam = JSON.stringify({
          creatorCode: JSON.parse(localStorage.getItem("userInfo")).id,
          creatorName: JSON.parse(localStorage.getItem("userInfo")).name,
          filename: "",
        });
        const loading = this.$loading({
          lock: true,
          text: "正在上传文件...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const formData = new FormData();
        formData.append("file", file);
        formData.append("searchParam", searchParam);
        const res = await fileUpload(formData);

        if (res.data.code == 200) {
          loading.close();
          let quill = this.$refs.quillEditor.quill
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'image', res.data.data[0].fileVisitPath)
          // 调整光标到最后
          quill.setSelection(length + 1)
          // this.fileList.push({
          //   url: res.data.data[0].fileVisitPath,
          //   id: res.data.data[0].id,
          //   name: res.data.data[0].fileOldName,
          //   type: res.data.data[0].fileType,
          // });
          // this.form.accessory = [{
          //   url: res.data.data[0].fileVisitPath,
          //   id: res.data.data[0].id,
          //   name: res.data.data[0].fileOldName,
          //   type: res.data.data[0].fileType,
          // }]
        } else loading.close();
        // 如果传的是视频
      } else if (file.type == 'video/mp4' || file.type == 'video/quicktime') {
        const searchParam = JSON.stringify({
          creatorCode: JSON.parse(localStorage.getItem("userInfo")).id,
          creatorName: JSON.parse(localStorage.getItem("userInfo")).name,
          filename: "",
        });
        const loading = this.$loading({
          lock: true,
          text: "正在上传文件...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const formData = new FormData();
        formData.append("file", file);
        formData.append("searchParam", searchParam);
        const res = await fileUpload(formData);

        if (res.data.code == 200) {
          loading.close();
          let quill = this.$refs.quillEditor.quill
          let length = quill.getSelection().index
          quill.insertEmbed(length, 'video', res.data.data[0].fileVisitPath)
          // 调整光标到最后
          quill.setSelection(length + 1)
          // this.fileList.push({
          //   url: res.data.data[0].fileVisitPath,
          //   id: res.data.data[0].id,
          //   name: res.data.data[0].fileOldName,
          //   type: res.data.data[0].fileType,
          // });
          // this.form.accessory = [{
          //   url: res.data.data[0].fileVisitPath,
          //   id: res.data.data[0].id,
          //   name: res.data.data[0].fileOldName,
          //   type: res.data.data[0].fileType,
          // }]
        } else loading.close();
      }

    },
  },
  components: {
    Dialogs,
    quillEditor
  },
  watch: {
    dialog: {
      handler(val) {
        this.$set(this, 'data', val)
      },
      immediate: true
    },
    handleClose: {
      handler(val) {
        this.$set(this, 'close', val)
      },
      immediate: true
    },
    isView: {
      handler(val) {
        this.$set(this, 'showBtn', val)
      },
      immediate: true
    },
    formData: {
      handler(val) {
        this.fileList = []

        this.$set(this, 'form', val)
        this.$nextTick(() => {
          if (this.$refs.form)
            this.$refs.form.clearValidate();
        })
      },
    },
  }
}
</script>
<style scoped>
@import "../css/quill-editor.css";

::v-deep .inlinitem.el-form-item {
  display: inline-flex;
  justify-content: flex-start;
}

::v-deep .inlinitem.el-form-item .el-form-item__content {
  margin-left: 2px !important;
}

.h120 {
  height: 120px;
}

::v-deep .h120 .el-textarea__inner {
  height: 120px;
}

.detail_theme {
  margin: 16px 0;
  font-size: 24px;
  text-align: center;
  color: #333;
}

.detail_content {
  margin-bottom: 20px;
  font-size: 16px;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: '微软雅黑';
  color: #333;
}

.detail_file a {
  color: #409EFF;
  text-decoration: none;
}

.detail_file img,
.detail_file video {
  width: 100%;
  display: block;
}

.detail-file-item {
  margin-bottom: 20px;
}

.file-preview {
  display: flex;
  align-items: flex-start;
  margin-left: 10px;
}

.delete-button {
  background-color: transparent;
  color: rgb(8, 8, 8);
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  z-index: 10;
}

.delete-button:hover {
  background-color: transparent;
}

/* ::v-deep .ql-container .ql-snow {
  height: 100%;
} */

::v-deep .ql-editor {
  border-color: #ccc;
  /* height: 125px !important; */
  height: 125px;
  /* height: 100% ; */
  overflow: auto;
}
</style>
